/**
 * El sexo de la ficha del paciente (16/10/2026). La regla vive en el servidor
 * (services/sexo_paciente.py); aquí, las mismas cuatro opciones para elegir y
 * cómo se lee lo que ya había.
 *
 *  · «Mujer», «Hombre», «Otro» y «No consta». «No consta» es una RESPUESTA
 *    (se preguntó y no se sabe); el campo vacío es «sin dato».
 *  · Lo de antes que no es ninguna de las cuatro («F», «M»…) no se traduce
 *    (la «M» es ambigua): se enseña como dato antiguo y se elige una.
 */
export const OPCIONES_SEXO = ['Mujer', 'Hombre', 'Otro', 'No consta'];

const SINONIMOS = {
  mujer: 'Mujer', femenino: 'Mujer', fem: 'Mujer',
  hombre: 'Hombre', masculino: 'Hombre', varon: 'Hombre', masc: 'Hombre',
  otro: 'Otro', otra: 'Otro', otros: 'Otro',
  noconsta: 'No consta', nc: 'No consta', nosabe: 'No consta', desconocido: 'No consta',
};

function plano(valor) {
  return String(valor ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/[^a-z0-9]/g, '');
}

/** La opción que dice `valor`; '' si está vacío; null si es un dato de
 *  antes que no se sabe leer. */
export function sexoCanonico(valor) {
  if (valor === null || valor === undefined || !String(valor).trim()) return '';
  return SINONIMOS[plano(valor)] || null;
}

/** Cómo se lee en la ficha: la opción, «—» sin dato, o el dato antiguo tal cual. */
export function sexoLegible(valor) {
  const c = sexoCanonico(valor);
  if (c === '') return '—';
  return c || `${String(valor).trim()} (dato antiguo)`;
}

/** Para el atributo data-testid: «No consta» → «no-consta». */
export function claveSexo(opcion) {
  return plano(opcion) === 'noconsta' ? 'no-consta' : plano(opcion);
}
